module.exports = __webpack_public_path__ + "static/media/rtu_logo_square.ecd50774.svg";